import { createSelector } from "@reduxjs/toolkit";

import { RootState } from "../store";

const taskState = (state: RootState) => state.task;

const selectTasksSettings = createSelector(
  taskState,
  (state) => state.tasksSettings,
);

const selectAllTasks = createSelector(
  taskState,
  (state) => state.allTasks || [],
);

const selectAllTasksLoading = createSelector(
  taskState,
  (state) => state.allTasksLoading,
);

const selectAllTasksMeta = createSelector(
  taskState,
  (state) => state.allTasksMeta,
);

const selectTasksPage = createSelector(
  taskState,
  (state) => state.tasksPage || 1,
);

const selectTasksPageSize = createSelector(
  taskState,
  (state) => state.tasksPageSize || 10,
);

const selectTodayTasks = createSelector(
  taskState,
  (state) => state.todayTasks || [],
);

const selectTodayTasksLoading = createSelector(
  taskState,
  (state) => state.todayTasksLoading,
);

const selectTaskById = createSelector(
  [taskState, (_, taskId: string) => taskId],
  (state, taskId) => state.allTasks.find(({ _id }) => _id === taskId),
);

export const taskSliceSelectors = {
  selectTasksSettings,
  selectAllTasks,
  selectAllTasksLoading,
  selectAllTasksMeta,
  selectTasksPage,
  selectTasksPageSize,
  selectTodayTasks,
  selectTodayTasksLoading,
  selectTaskById,
};
